import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonEntityService } from 'src/app/common/services/common-entity.service';

interface TriggerRow {
  trigger: any | null;
  selectedOption: string | null;
}

@Component({
  selector: 'app-animation-trigger-map-input',
  templateUrl: './animation-trigger-map-input.component.html',
  styleUrls: ['./animation-trigger-map-input.component.sass'],
})
export class AnimationTriggerMapInputComponent implements OnInit {
  @Input() field: any;
  @Input() record: any;
  @Input() value: { [triggerId: string]: string } | null;
  @Output() valueChange = new EventEmitter<{ [triggerId: string]: string }>();

  rows: TriggerRow[] = [];
  allTriggers: any[] = [];

  constructor(private commonEntityService: CommonEntityService) {}

  async ngOnInit(): Promise<void> {
    try {
      const result = await this.commonEntityService.findAllWithQuery('animation-triggers', {
        query: {},
        select: 'name id _id options',
        sort: { name: 1 },
        autopopulate: false,
        virtuals: false,
        isOptions: true,
      } as any);
      this.allTriggers = result || [];
    } catch {
      this.allTriggers = [];
    }

    if (this.value && typeof this.value === 'object' && !Array.isArray(this.value)) {
      this.rows = Object.entries(this.value).map(([triggerId, selectedOption]) => {
        const trigger = this.allTriggers.find((t: any) => String(t.id) === String(triggerId)) ?? null;
        return { trigger, selectedOption };
      });
    }
  }

  getAvailableTriggers(currentRow: TriggerRow): any[] {
    const usedIds = this.rows
      .filter(r => r !== currentRow && r.trigger)
      .map(r => r.trigger.id);
    return this.allTriggers.filter(t => !usedIds.includes(t.id));
  }

  getOptionsForRow(row: TriggerRow): string[] {
    return row.trigger?.options ?? [];
  }

  addRow(): void {
    this.rows.push({ trigger: null, selectedOption: null });
  }

  removeRow(index: number): void {
    this.rows.splice(index, 1);
    this.emit();
  }

  onTriggerChange(row: TriggerRow, trigger: any): void {
    row.trigger = trigger;
    row.selectedOption = null;
    this.emit();
  }

  onOptionChange(row: TriggerRow, value: string): void {
    row.selectedOption = value;
    this.emit();
  }

  private emit(): void {
    const map: { [triggerId: string]: string } = {};
    for (const row of this.rows) {
      if (row.trigger && row.selectedOption) {
        map[String(row.trigger.id)] = row.selectedOption;
      }
    }
    this.valueChange.emit(map);
  }
}
